import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { ChiTietThueNamResponse, ChiTietThueThangItem, ChiTietThueThangKhongThuongXuyenResponse, DanhSachThueThangResponse, DsOptionsTinhThueThangKhongThuongXuyen, DsThueNamResponse, DuLieuThueThangKhongThuongXuyenResponse, KyTinhThueKhongThuongXuyenResponse, ThueThangInfo, TongHopThueKTXNamResponse } from "../models/thue/Thue";
import intance from "../utils/axios";

export const layDuLieuTinhThueKhongThuongXuyen = async (request: any) => {
    var rs: Array<DuLieuThueThangKhongThuongXuyenResponse> = [];
    await intance.post(ApiPaths.thue.layDuLieuTinhThueKhongThuongXuyen, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuThueThangKhongThuongXuyen = async (request: any) => {
    var rs: number = 0;
    await intance.post(ApiPaths.thue.luuThueThangKhongThuongXuyen, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};

export const layDanhSachKyThueKhongThuongXuyen = async (thang: string) => {
    var rs: Array<KyTinhThueKhongThuongXuyenResponse> = [];
    await intance.get(ApiPaths.thue.layDsKyThueKhongThuongXuyen + "?thang=" + thang)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layChiTietThueThangKhongThuongXuyen = async (id: number) => {
    var rs: ChiTietThueThangKhongThuongXuyenResponse = new ChiTietThueThangKhongThuongXuyenResponse();
    await intance.get(ApiPaths.thue.layDuLieuThueThangKhongThuongXuyenTheoId + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layDsOptionsTinhThueKhongThuongXuyen = async (thang: any, nam: any) => {
    var rs = new DsOptionsTinhThueThangKhongThuongXuyen();
    await intance.get(ApiPaths.thue.layDSOptionCacKhoanTinhThueKhongThuongXuyen + "?thang=" + thang + "&nam=" + nam).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const luuQuyetToanThue = async (request: any) => {
    var rs = 0;
    await intance.post(ApiPaths.thue.luuQuyetToanThueTX, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });

    return rs;
}

export const layChiTietQuyetToanThueThuongXuyen = async (id: number) => {
    var rs: ChiTietThueNamResponse = new ChiTietThueNamResponse();
    await intance.get(ApiPaths.thue.chiTietQuyetToanThueTX + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layDsQuyetToanThueThuongXuyen = async () => {
    var rs: Array<DsThueNamResponse> = [];
    await intance.get(ApiPaths.thue.layDsQTThueThuongXuyen)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const XuatExcelBaoCaoThueTNCN = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.thue.xuatExcelThueTNCN + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const XuatExcelBaoCaoThueTNCN_KTX = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.thue.xuatExcelThueTNCN_KTX + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const layLayDuLieuTongHopThueKTXTheoNam = async (nam: number) => {
    var rs: Array<TongHopThueKTXNamResponse> = [];
    await intance.get(ApiPaths.thue.layTongHopThueKTXTHeoNam + "?nam=" + nam)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

// === Nâng cấp thuế ===
export const layThongTinThueThang = async (id: number): Promise<ThueThangInfo> => {
    var rs: ThueThangInfo = new ThueThangInfo();
    await intance.get(ApiPaths.thue.layThongTinThueThang + '?id=' + id)
        .then(
            (res) => {
                if (res.data.trangThai === responseStatus.thanhCong)
                    rs = res.data.duLieu;
            })
        .catch((err) => { throw err; });
    return rs;
};

export const taiThueThang = async (id: number): Promise<ChiTietThueThangItem[]> => {
    var rs: ChiTietThueThangItem[] = [];
    await intance.get(ApiPaths.thue.taiThueThang + '?id=' + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu ?? [];
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

export const layChiTietThueTNCNThang = async (id: number): Promise<ChiTietThueThangItem[]> => {
    var rs: any[] = [];
    await intance.get(ApiPaths.thue.layChiTietThueTNCNThang + '?id=' + id)
        .then(
            (res) => {
                if (res.data.trangThai === responseStatus.thanhCong)
                    rs = res.data.duLieu ?? [];
            })
        .catch((err) => { throw err; });
    return rs;
};

export const capNhatDuLieuThamChieuThueThang = async (request: any): Promise<void> => {
    await intance.post(ApiPaths.thue.capNhatDuLieuThamChieuThueThang, request)
        .then(
            (res) => {
                if (res.data.trangThai !== responseStatus.thanhCong)
                    throw Error(res.data.thongBao);
            })
        .catch((err) => { throw err; });
};

export const luuThueThang = async (request: any) => {
    var rs: number = 0;
    await intance.post(ApiPaths.thue.luuThueThang, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};

export const xoaThueThang = async (id: number) => {
    var rs: boolean = false;
    await intance.post(ApiPaths.thue.xoaThueThang + `?id=${id}`).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};

export const timKiemDsThueThang = async (pageNumber: number, pageSize: number, thoiGian?: string, loaiChuKy?: number) => {
    var rs: any;
    let url = ApiPaths.thue.timKiemDsThueThang + `?start=${pageNumber}&length=${pageSize}`;
    if (loaiChuKy && loaiChuKy > 0) {
        url += `&loaiChuKy=${loaiChuKy}`;
    }
    if (thoiGian) {
        url += `&thangNam=${thoiGian}`;
    }
    await intance.get(url).then((res) => {
        rs = res.data.duLieu;
    });
    return rs;
}

export const layDsThueThangTheoNam = async (nam?: number) => {
    var rs: Array<DanhSachThueThangResponse> = [];
    const qs = nam ? `?nam=${nam}` : '';
    await intance.get(ApiPaths.thue.layDsThueThangTheoNam + qs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const khoiTaoThueThang = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.thue.khoiTaoThueThang, request).then((res) => {
        if (res.data.trangThai === 0) {
            throw new Error(res.data.thongBao);
        }
        rs = res.data.duLieu;
    });
    return rs;
}

export const duyetThueThang = async (id: number) => {
    var rs: any;
    await intance.post(ApiPaths.thue.duyetThueThang + `?id=${id}`).then((res) => {
        if (res.data.trangThai === 0) {
            throw new Error(res.data.thongBao);
        }
        rs = res.data.duLieu;
    });
    return rs;
}

export const layDuLieuTongHopThue = async (request: any): Promise<any> => {
    var rs: any = null;
    await intance.post(ApiPaths.thue.layDuLieuTongHopThue, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const xuatExcelTongHopThue = async (request: any) => {
    await intance.post(ApiPaths.thue.xuatExcelTongHopThue, request, {
        responseType: 'blob'
    }).then((res: any) => {
        const file = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', `TongHopThue_${request.nam ?? new Date().getFullYear()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
    }).catch((err) => {
        throw err;
    });
};

// ==================== MÔ-ĐUN TỔNG HỢP THUẾ (THÁNG / QUÝ / NĂM) ====================

export const khoiTaoThueTongHop = async (request: any): Promise<any> => {
    let rs: any = null;
    await intance.post(ApiPaths.thue.khoiTaoThueTongHop, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

export const timKiemDsThueTongHop = async (pageNumber: number, pageSize: number, thoiGian?: string, loaiChuKy?: number) => {
    let rs: any;
    let url = ApiPaths.thue.timKiemDsThueTongHop + `?start=${pageNumber}&length=${pageSize}`;
    if (loaiChuKy !== undefined && loaiChuKy >= 0) {
        url += `&loaiChuKy=${loaiChuKy}`;
    }
    if (thoiGian) {
        url += `&thangNam=${thoiGian}`;
    }
    await intance.get(url).then((res) => {
        rs = res.data.duLieu;
    }).catch((err) => { throw err; });
    return rs;
};

export const layThongTinThueTongHop = async (id: number): Promise<any> => {
    let rs: any = null;
    await intance.get(ApiPaths.thue.layThongTinThueTongHop + `?id=${id}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

export const taiThueTongHop = async (id: number): Promise<any> => {
    let rs: any = null;
    await intance.get(ApiPaths.thue.taiThueTongHop + `?id=${id}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
    return rs;
};

export const luuThueTongHop = async (request: any): Promise<void> => {
    await intance.post(ApiPaths.thue.luuThueTongHop, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const capNhatThamChieuThueTongHop = async (request: any): Promise<void> => {
    await intance.post(ApiPaths.thue.capNhatThamChieuThueTongHop, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const duyetThueTongHop = async (id: number): Promise<void> => {
    await intance.post(ApiPaths.thue.duyetThueTongHop + `?id=${id}`)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const xoaThueTongHop = async (id: number): Promise<void> => {
    await intance.post(ApiPaths.thue.xoaThueTongHop + `?id=${id}`)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => { throw err; });
};

export const xuatExcelThueTongHop = async (id: number, tenKy?: string) => {
    await intance.get(ApiPaths.thue.xuatExcelThueTongHop + `?id=${id}`, {
        responseType: 'blob'
    }).then((res: any) => {
        const file = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', `${tenKy || `TongHopThue_${id}`}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
    }).catch((err) => {
        throw err;
    });
};
